var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_3343_17151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 -0.0507812C10.7402 -0.0507812 -0.0507812 10.7372 -0.0507812 24.0002C-0.0507812 37.2632 10.7402 48.0512 24.0017 48.0512C37.2632 48.0512 48.0542 37.2632 48.0542 24.0002C48.0542 10.7372 37.2632 -0.0507812 24.0017 -0.0507812ZM24.0017 46.4492C11.6237 46.4492 1.55422 36.3782 1.55422 24.0002C1.55422 11.6222 11.6237 1.55122 24.0017 1.55122C36.3797 1.55122 46.4492 11.6222 46.4492 24.0002C46.4492 36.3782 36.3797 46.4492 24.0017 46.4492Z",
    fill: "#0d5225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.668 19.334C30.5245 19.334 32.305 20.0715 33.6177 21.3842C34.9305 22.697 35.668 24.4775 35.668 26.334V34.5007H31.0013V26.334C31.0013 25.7151 30.7555 25.1217 30.3179 24.6841C29.8803 24.2465 29.2868 24.0007 28.668 24.0007C28.0491 24.0007 27.4556 24.2465 27.0181 24.6841C26.5805 25.1217 26.3346 25.7151 26.3346 26.334V34.5007H21.668V26.334C21.668 24.4775 22.4055 22.697 23.7182 21.3842C25.031 20.0715 26.8115 19.334 28.668 19.334V19.334Z",
    stroke: "#0d5225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 20.5H12.332V34.5H16.9987V20.5Z",
    stroke: "#0d5225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 17.0007C15.954 17.0007 16.9987 15.956 16.9987 14.6673C16.9987 13.3787 15.954 12.334 14.6654 12.334C13.3767 12.334 12.332 13.3787 12.332 14.6673C12.332 15.956 13.3767 17.0007 14.6654 17.0007Z",
    stroke: "#0d5225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3343_17151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e1df370c83c86a12505de4d84dd13d48.svg";
export { ForwardRef as ReactComponent };